export default "__VITE_ASSET__DTGMH62A__"